<div class="book-info-container">

    <div class="row">
        <div class="col-sm-12">
            <div class="col-md-12 col-sm-12" id="bookTitle">
                {{ applicationStateService.bookConfig.name }}
            </div>
        </div>
    </div>

    <br/>

    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="bookSBN">SBN</label>
                <div class="col-md-6 col-sm-8 text-start" id="bookSBN">
                    {{ applicationStateService.bookConfig.sbn || '-' }}
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="bookISBN">ISBN</label>
                <div class="col-md-6 col-sm-8 text-start" id="bookISBN">
                    {{ applicationStateService.bookConfig.isbn || '-' }}
                </div>
            </div>
        </div>
    </div>

    <br/>

    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="ebookSbn">SBN
                    (eBook)</label>
                <div class="col-md-6 col-sm-8 text-start" id="ebookSbn">
                    {{ applicationStateService.bookConfig.ebookSbn || '-' }}
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="ebookEdition">ISBN
                    (eBook)</label>
                <div class="col-md-6 col-sm-8 text-start" id="ebookEdition">
                    {{ applicationStateService.bookConfig.ebookIsbn || '-' }}
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="ebookPlusSbn">SBN
                    (eBook Plus)</label>
                <div class="col-md-6 col-sm-8 text-start" id="ebookPlusSbn">
                    {{ applicationStateService.bookConfig.ebookPlusSbn || '-' }}
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="ebookPlusEdition">ISBN
                    (eBook Plus)</label>
                <div class="col-md-6 col-sm-8 text-start" id="ebookPlusEdition">
                    {{ applicationStateService.bookConfig.ebookPlusIsbn || '-' }}
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="ebookSoloSbn">SBN
                    (eBook Solo)</label>
                <div class="col-md-6 col-sm-8 text-start" id="ebookSoloSbn">
                    {{ applicationStateService.bookConfig.ebookSoloSbn || '-' }}
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="ebookSoloEdition">ISBN
                    (eBook Solo)</label>
                <div class="col-md-6 col-sm-8 text-start" id="ebookSoloEdition">
                    {{ applicationStateService.bookConfig.ebookSoloIsbn || '-' }}
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="ebookSoloPlusSbn">SBN
                    (eBook Solo Plus)</label>
                <div class="col-md-6 col-sm-8 text-start" id="ebookSoloPlusSbn">
                    {{ applicationStateService.bookConfig.ebookSoloPlusSbn || '-' }}
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-6 col-sm-4 text-end" for="ebookSoloPlusEdition">ISBN
                    (eBook Solo Plus)</label>
                <div class="col-md-6 col-sm-8 text-start" id="ebookSoloPlusEdition">
                    {{ applicationStateService.bookConfig.ebookSoloPlusIsbn || '-' }}
                </div>
            </div>
        </div>
    </div>

    <br/>

    <div class="row margin-b-small">
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-sm-4  text-end" for="bookPublisher">Verlag</label>
                <div class="col-sm-8 text-start" id="bookPublisher">
                    Bildungsverlag Lemberger
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-sm-4  text-end" for="bookWebsite">Website</label>
                <div class="col-sm-8 text-start" id="bookWebsite">
                    <a [attr.href]="'https://www.bildungsverlag-lemberger.at'" class="website" target="_blank">
                        www.bildungsverlag-lemberger.at
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-md-4 col-sm-4  text-end" for="bookContact">Kontakt</label>
                <div class="col-md-8 col-sm-8 text-start" id="bookContact">
                    <a [attr.href]="'mailto:support@lemberger.at'">support@lemberger.at</a><br/>
                    <a [attr.href]="'tel:+43 1 997 15 21'">+43 1 997 15 21</a>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-12">
            <div class="row">
                <label class="col-sm-4  text-end" for="bookAddress">Adresse</label>
                <div class="col-sm-8 text-start" id="bookAddress">
                    Pointengasse 21-23/Top 11, 1170 Wien
                </div>
            </div>
        </div>
    </div>

    @if (applicationStateService.bookConfig.ebookPlusIsbn) {
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <label class="col-md-4 col-sm-4  text-end" for="bookEdition">Auflage</label>
                    <div class="col-md-8 col-sm-8 text-start" id="bookEdition">
                        {{ applicationStateService.bookConfig.editionNum + ' / ' + applicationStateService.bookConfig.editionYear }}
                    </div>
                </div>
            </div>
        </div>
    }
</div>